export const InternalOrderActionsUpdatedEvent = 'internal-order-actions-updated';
